module.exports = __webpack_public_path__ + "img/meiyu.077f6063.png";